<template>

  <el-header>


    <el-dropdown class="hand" trigger="click">
      <span class="el-dropdown-link user">
            <el-select @change="changeCurrentTeam" placeholder="请选择部门" v-model="selectTeamID">
              <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in TeamOptions">
              </el-option>
            </el-select>
          </span>
      <el-dropdown-menu></el-dropdown-menu>
    </el-dropdown>

    <el-badge :value="messageCount" class="item hand" style="margin-right: 20px;">
      <i @click="showMessage" class="el-icon-message-solid" style="font-size: 30px;"></i>
    </el-badge>

    <el-dropdown class="hand" trigger="click">
      <span class="el-dropdown-link user">
        <el-avatar fit="fill" size="large" style="background-color: #dfe4ed">
          <img :src=user.avatar>
        </el-avatar>
          <span class="username">
            <span>{{ user.userName }}</span>
            <span class="el-icon-arrow-down" style="margin-left: 10px"></span>
          </span>
      </span>
      <el-dropdown-menu slot="dropdown">
        <div @click="updateUserMessage">
          <el-dropdown-item>用户设置</el-dropdown-item>
        </div>

        <!--        <div @click="UserTeamInfo">-->
        <!--          <el-dropdown-item>部门设置</el-dropdown-item>-->
        <!--        </div>-->

        <div @click="logout">
          <el-dropdown-item divided>退出登录</el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>


    <el-dialog :visible.sync="formVisible" title="正在告警的警报信息" width="1000px">
      <el-table :data="tableData"
                border
                style="width: 100%">
        <el-table-column
            label="警报ID"
            prop="alertID"
            width="100">
        </el-table-column>
        <el-table-column
            label="警报名称"
            prop="alertName"
            width="200">
        </el-table-column>
        <el-table-column
            label="警报标题"
            prop="messageTitle"
            width="200">
        </el-table-column>
        <el-table-column
            label="警报正文"
            prop="messageTxt"
            width="300">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
                @click="ReceivedMessage(scope.row,scope.index)"
                size="mini"
                type="danger">收到
            </el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-dialog>


  </el-header>

</template>


<script>
import {Apis} from "@/api";
import {Utils} from "@/utils/utils";


export default {
  data() {
    return {
      selectTeamID: "",

      TeamOptions: [],

      formLabelWidth: '120px',
      messageCount: 0,
      formVisible: false,
      user: {},

      tableData: [
        {
          alertID: "",
          alertName: "",
          messageTitle: "",
          messageTxt: "",
        }
      ]
    }
  },
  methods: {
    showMessage() {
      this.formVisible = true
    },
    logout() {
      Utils.Logout()
      window.location.href = "/login"

      //清除所有cookie信息
      this.$cookies.remove("currentTeamID");
      this.$cookies.remove("token");
      this.$cookies.remove("openID");

      //无法跨域删除开放平台的cookie，所以暂不支持退出登录
    }
    ,

    changeCurrentTeam() {
      //移除原有cookie，当前部门ID和部门名称放入cookie中
      this.$cookies.remove("currentTeamID");
      this.$cookies.set("currentTeamID", this.selectTeamID, 60 * 60 * 12); // 12 hour after, expire

      //更换当前部门后重新跳转到首页
      this.$router.push({name: "Index"})

      this.$router.go(0)//强制刷新当前页面
    }
    ,

    updateUserMessage() {
      this.$router.push({name: "Update"})
    }
    ,
    UserTeamInfo() {
      this.$router.push({name: "Teams"})
    }
    ,

    async initMessage() {

      const response = await Apis.Message.MessageNotice()
      this.tableData = response.data || []
      this.messageCount = this.tableData.length

    }
    ,

    async ReceivedMessage(row, index) {

      const response = await Apis.Message.MessageReceived(row.alertID)
      if (response != null && response.errno === 0) {

        this.$message.success("该警报已停止告警!");

        //删除前端表中的告警数据
        this.tableData.splice(index, 1)
        if (this.tableData == null) {
          this.messageCount = 0
        } else {
          this.messageCount = this.tableData.length
        }

      }

    }
    ,

    async initTeamOptions() {
      this.isLogin = Utils.isLogin()

      if (this.isLogin === true) {
        const response = await Apis.Team.listTeam()
        this.TeamOptions = response.data || []

        if (this.$cookies.get("currentTeamID") === null) {
          if (this.TeamOptions.length !== 0) {
            this.selectTeamID = this.TeamOptions[0]["value"]

          } else {
            this.selectTeamID = ""
            this.$message.error("请先选择一个部门加入")
          }
        } else {
          this.selectTeamID = parseInt(this.$cookies.get("currentTeamID"))
        }
        //移除原有cookie，加入新cookie
        this.$cookies.remove("currentTeamID");
        this.$cookies.set("currentTeamID", this.selectTeamID, 60 * 60 * 12); // 12 hour after, expire
      }

    }
    ,

  },
  created: async function () {

    this.user = Utils.getCurrentUser() ?? {username: ""}

    console.log("准备打印flag")
    const flag = Utils.isInitTeam()
    console.log("flag: ", flag)

    if (this.user.username !== "" && flag) {
      //先执行cookie值初始化操作，后面用到cookie值的函数才能通过权限校验
      await this.initTeamOptions()

      //初始化 通知
      await this.initMessage()
    }

  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-header {
  background-color: #fff;
  width: 100%;
  height: 60px;
  margin-bottom: 5px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .12), 0 0 0px rgba(0, 0, 0, .04);
  display: flex;
  align-items: center;
  justify-content: flex-end;

}

.user {
  display: flex;
  align-items: center;
  margin-right: 20px;
}

.username {
  font-weight: 400;
  margin: 0 8px;
}

</style>
